export const QUOTE_TOPIC = '/topic/selection';

export enum QuoteMessages {
  LogMessage = 'LogMessage',
}
